import React from 'react';
import { useSearchStateLocation } from './hooks/useSearchStateLocation';
import { useSearchBox } from 'react-instantsearch-hooks-web';

const SearchHitsOverlay = () => {
    const { stateAsLocation, submarket, cities } = useSearchStateLocation();
    const { query } = useSearchBox();

    if (stateAsLocation.name || submarket.submarket || query || cities) {
        return null;
    }

    return <div className="tw-bg-white tw-opacity-80 tw-h-full tw-w-full tw-absolute tw-z-20"></div>;
};

export default SearchHitsOverlay;
